import FakeButton from "@/components/fake-button";

type Props = {
  noticeMessage: string;
};

const Notice = ({ noticeMessage }: Props) => {
  return (
    <FakeButton size="2xl" className="mb-1 wrap-break-word leading-none">
      <p>{noticeMessage}</p>
    </FakeButton>
  );
};

Notice.displayName = "Notice";

export default Notice;
